
import { AmmunitionStockEventRowsEntityDecoratorBase } from './ammunition-stock-event-rows.decorator.base';
import { AmmunitionStockEventEntityDecorator } from './ammunition-stock-event.decorator';


export class AmmunitionStockEventRowsEntityDecorator extends AmmunitionStockEventRowsEntityDecoratorBase<any> {
  constructor() {
    super(new AmmunitionStockEventEntityDecorator(), null);
  }
}



